import { BASE_CLASS_PREFIX } from '../base/constants';

const cssClasses = {
    PREFIX: `${BASE_CLASS_PREFIX}-form`,
};

const strings = {
    LAYOUT: ['horizontal', 'vertical'],
    LABEL_POS: ['left', 'top', 'inset'],
    LABEL_ALIGN: ['left', 'right'],
    EXTRA_POS: ['middle', 'bottom'],
    DEFAULT_TRIGGER: 'change',
};

const numbers = {};

export { cssClasses, strings, numbers };